import React from "react";
import { AdminLayout } from "./AdminLayout";
import { Card, CardContent } from "../ui/card";

export const AdminPlaceholderPage = ({ title }) => {
  return (
    <AdminLayout description="Cette rubrique admin sera détaillée dans une prochaine étape, tout en conservant la même structure que le site visiteur." title={title}>
      <Card className="rounded-[2rem] border border-[#d9e7d5]/90 bg-white/92 shadow-[0_24px_70px_-48px_rgba(15,118,110,0.2)]" data-testid="admin-placeholder-card">
        <CardContent className="p-10 text-slate-600" data-testid="admin-placeholder-copy">
          Cette page est préparée dans la structure admin, mais son contenu détaillé n’est pas encore implémenté.
        </CardContent>
      </Card>
    </AdminLayout>
  );
};